import { AutogenLayoutRateIndexResultsData } from "./autogen/AutogenLayoutRateIndexResultsData";

export class RateIndexResultsData extends AutogenLayoutRateIndexResultsData {

}
